export const SET_ROLES_AND_THEIR_PERMISSIONS = "SET_ROLES_AND_THEIR_PERMISSIONS";
export const UPDATE_ROLES_AND_THEIR_PERMISSIONS = "UPDATE_ROLES_AND_THEIR_PERMISSIONS";
